import styled, { css } from 'styled-components';
import { PADDING_SMALL } from './divider.constants';
import {
  themeSize,
  themeColor,
  whenThemePropEqualsExpectedValue,
  whenThemePropEqualsTrue,
} from '../../../theme/getters';

const whenIsPaddingSmall = whenThemePropEqualsExpectedValue('paddingSize', PADDING_SMALL);

const getPaddingSmallContainerStyles = whenIsPaddingSmall(
  () => css`
    margin: 32px 0;
  `
);

const smallStyles = css`
  width: calc(100% - 2 * ${themeSize('contentPadding')}px);
  max-width: calc(1600px - 2 * ${themeSize('contentPadding')}px);
`;

const small = css`
  ${smallStyles};
  margin: 56px auto;
`;

const smallWithoutMargin = css`
  ${smallStyles};
  margin: 0 auto;
`;

export const Container = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${themeColor('middleGray')};
  margin: 56px 0;
  box-sizing: border-box;

  ${getPaddingSmallContainerStyles};

  ${whenThemePropEqualsTrue('small', () => small)}
  ${whenThemePropEqualsTrue('smallWithoutMargin', () => smallWithoutMargin)}
`;
